(function () {
  if (window.__dealCardTitleAdaptiveInit) return;
  window.__dealCardTitleAdaptiveInit = true;

  var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function fitTitle(el) {
    if (!isDesktop()) {
      el.classList.remove('deal-card__title-adaptive--use-short');
      return;
    }

    var fullSpan = el.querySelector('.deal-card__title-full');
    if (!fullSpan) return;

    el.classList.remove('deal-card__title-adaptive--use-short');

    if (el.scrollWidth > el.clientWidth + 1) {
      el.classList.add('deal-card__title-adaptive--use-short');
    }
  }

  function fitAll(root) {
    (root || document).querySelectorAll('.deal-card__title-adaptive[data-title-short]').forEach(fitTitle);
  }

  function init() {
    fitAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  DESKTOP_MQ.addEventListener('change', function () {
    fitAll(document);
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      fitAll(document);
    }, 100);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      fitAll(document);
    });
  }
})();
